import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cleanString } from "@/helpers/cleanString";
import { Link } from "@/i18n/navigation";
import { AdminRole } from "@/types/auth/LoginUserTypes";
import { signOut } from "next-auth/react";
import { useTranslations } from "next-intl";

interface PropsType {
  showRedirectionModal: boolean;
  setShowRedirectionModal: React.Dispatch<React.SetStateAction<boolean>>;
  adminRole: AdminRole | null;
}

const redirectUrls = {
  reseller: "https://partner.esimcard.com/login",
  dealer: "https://partner.esimdelivery.com/login",
  affiliate: "https://partner.esimcard.com/login",
  admin: "https://portal.esimcard.com/portal",
};

function LoginRedirectionModal({
  setShowRedirectionModal,
  showRedirectionModal,
  adminRole,
}: PropsType) {
  const t = useTranslations(`Shared.auth.loginRedirectionModal`);
  const nonce = adminRole?.nonce;
  const role = cleanString(adminRole?.type as string);
  const displayRole = role.charAt(0).toUpperCase() + role.slice(1);

  const redirectUrl =
    redirectUrls[role as keyof typeof redirectUrls] || redirectUrls.admin;

  function handleOpenChange(open: boolean) {
    setShowRedirectionModal(open);
    if (!open) {
      void signOut({ redirect: false });
    }
  }

  return (
    <Dialog open={showRedirectionModal} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader className="mt-2">
          <DialogTitle className="font-montserrat">
            {t(`title`, { role: displayRole })}
          </DialogTitle>
          <DialogDescription>
            {t(`description`, { role: displayRole })}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 flex flex-col gap-4">
          <Link
            href={`${redirectUrl}?nonce=${nonce}`}
            className="w-full"
            onClick={() => handleOpenChange(false)}
          >
            <Button className="w-full">
              {t(`buttons.goToPortal`, { role: displayRole })}
            </Button>
          </Link>
          <Button
            variant={"outline"}
            onClick={() => handleOpenChange(false)}
          >
            {t(`buttons.stayOnPage`)}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default LoginRedirectionModal;
